import { PropsWithChildren, FC } from 'react'
import { ACTION_TYPES_TITLE } from '@ProdWb/JobDetails/AutoExceptionActionButton/constants'
import styles from '@ProdWb/JobDetails/styles.css'

import Button from '~/core/Button'
import Text from '~/core/Text'

const PLACEMENT = 'job-details-header'

type ActionButtonProps = {
    name: string
    dataTestTarget: string
    actionType: string
    onClick: (buttonName: string) => void
    color?: string
    className: string
}

const AutoExceptionActionButton: FC<
    PropsWithChildren<ActionButtonProps>
> = props => {
    const { name, dataTestTarget, actionType, onClick, className, color } =
        props

    return (
        <Button
            name={name}
            placement={PLACEMENT}
            data-test-target={dataTestTarget}
            onClick={(evt: Event) => {
                evt.stopPropagation()
                evt.preventDefault()
                onClick(actionType)
            }}
            className={className}
            style={color ? { color } : {}}
        >
            <Text className={styles.createResumeExceptionButtonText}>
                {ACTION_TYPES_TITLE[actionType]}
            </Text>
        </Button>
    )
}

export default AutoExceptionActionButton
